import { useProgressAlt } from './progressAltContext';
import type { ProgressAltTileSizeId } from './progressAltMetrics';
import { type ProgressAltSegment, ProgressAltSegmentedControl } from './ProgressAltSegmentedControl';

/**
 * Each size drawn as what it produces: a rectangle in the photo tiles' own proportion, sitting in a
 * shared 16px box so the two read as the same picture at two scales.
 */
const TILE_SIZE_ICON_RECTS: Record<ProgressAltTileSizeId, { x: number; y: number; width: number; height: number }> = {
  small: { x: 4, y: 5.5, width: 8, height: 5 },
  large: { x: 1.5, y: 4, width: 13, height: 8 },
};

const TileSizeIcon = ({ tileSizeId }: { tileSizeId: ProgressAltTileSizeId }) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
    <rect {...TILE_SIZE_ICON_RECTS[tileSizeId]} rx='1' stroke='currentColor' strokeWidth='1.5' />
  </svg>
);

const TILE_SIZE_SEGMENTS: readonly ProgressAltSegment<ProgressAltTileSizeId>[] = [
  { id: 'small', label: 'Small thumbnails', content: <TileSizeIcon tileSizeId='small' /> },
  { id: 'large', label: 'Large thumbnails', content: <TileSizeIcon tileSizeId='large' /> },
];

/** Chooses how big the Progress Alt grid draws its photo tiles. */
export const ProgressAltTileSizePicker = () => {
  const { tileSizeId, selectTileSize } = useProgressAlt();
  return (
    <ProgressAltSegmentedControl
      ariaLabel='Thumbnail size'
      segments={TILE_SIZE_SEGMENTS}
      selectedId={tileSizeId}
      onSelect={selectTileSize}
    />
  );
};
